var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    "data-name": "Layer 1",
    id: "Layer_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f76c5e;\n      }\n\n      .cls-2 {\n        fill: #ffbc0a;\n      }\n\n      .cls-3 {\n        fill: #a3cef1;\n      }\n\n      .cls-4 {\n        fill: #6096ba;\n      }\n\n      .cls-5 {\n        fill: #274c77;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36,22v-2.81c1.09-.55,2.06-1.32,2.85-2.26-.26-.58-.25-1.27,.08-1.87,.34-.59,.92-.94,1.54-1,.34-.96,.53-1.99,.53-3.07s-.19-2.11-.53-3.07c-.62-.06-1.21-.41-1.54-1-.34-.59-.34-1.29-.08-1.87-1.32-1.57-3.14-2.68-5.22-3.06-.36,.52-.96,.86-1.63,.86s-1.27-.34-1.63-.86c-2.08,.39-3.9,1.5-5.22,3.06,.26,.58,.25,1.27-.08,1.87-.34,.59-.92,.94-1.54,1-.34,.96-.53,1.99-.53,3.07s.19,2.11,.53,3.07c.62,.06,1.21,.41,1.54,1,.34,.59,.34,1.29,.08,1.87,.78,.94,1.75,1.7,2.85,2.26v2.81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32,62h-3l-2-2H10v-24h4v18s12.15-3,18,8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M50,54v-18h4v24h-17s-2,2-2,2h-3c5.85-11,18-8,18-8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32,62c-5.85-11-18-8-18-8v-21l6-2v19c6.63,0,12,5.37,12,12Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44,31l6,2v21s-12.15-3-18,8c0-6.63,5.37-12,12-12V31Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32,42c0-6.63-5.37-12-12-12v20c6.63,0,12,5.37,12,12,0-6.63,5.37-12,12-12V30c-6.63,0-12,5.37-12,12Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 32,
    cy: 11,
    r: 5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4,
    rx: 1,
    ry: 1,
    width: 10,
    x: 27,
    y: 22
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 21,
    y: 17
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 18,
    y: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 14,
    y: 13
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 11,
    y: 17
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 11,
    y: 22
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 11,
    y: 28
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 44,
    y: 10
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 48,
    y: 13
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 51,
    y: 17
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 51,
    y: 22
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 51,
    y: 28
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 21,
    y: 21
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 21,
    y: 25
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 41,
    y: 17
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 41,
    y: 21
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 41,
    y: 25
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 31,
    y: 28
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    width: 2,
    x: 31,
    y: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.ba359f7d5e44f130acd018379ef1da58.svg";
export { ForwardRef as ReactComponent };